import React from 'react';
import { Button, makeStyles } from '@material-ui/core';

const MoveButton = (props) => {
    const { width, ...other } = props;
    const classes = useStyles(props);

    return (
        <Button
            width={props.width}
            position={props.position}
            className={classes.button}
            onClick={props.clickHandler}
            transform={props.transform}
        >{props.text}</Button>
    );
};

const useStyles = makeStyles({
    button: {
        width: (props) =>
            props.width ?
                'calc( 90% - 55px)'
                : '100%',

        position: (props) =>
            props.position &&
                'fixed',
        backgroundColor: '#fff',
        border: '2px solid #a5a5a5',
        borderRadius: '23px',
        boxShadow: '0px 5px 4px 0px rgba(0,0,0,0.2)',
        height: '47.3px',
        marginTop: '5px',
        boxSizing: 'border-box',
        padding: '0 22.5px',
        '@media (min-width: 600px)': {
            width: '273.1px !important',
        },
        bottom: (props) =>
            props.transform &&
                '20px',
        left: (props) =>
            props.transform &&
                '45%',
        transform: (props) =>
            props.transform &&
                'translateX(-50%)',
        '& span': {
            fontSize: '15px',
            color: '#262626',
            fontWeight: '800',
            fontFamily: 'inherit',
        },
        zIndex: '30',
    },
});

export default MoveButton;
